import React from "react";

import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  listItemSubItem: {
    paddingTop: 10,
    paddingBottom: 10,
    "& .MuiListItemText-primary": {
      fontSize: 14,
    },
  },
  listItemIcon: {
    color: colors.gray,
  },
  listItemText: {
    color: colors.dark,
  },
  listItemTextPrimary: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 1,
    letterSpacing: -0.5,
  },
  chevron: {
    color: colors.dark,
    minWidth: 0,
  },
  activeLink: {
    color: theme.palette.primary.main,
    "& .MuiListItemIcon-root": {
      color: "inherit",
    },
    "& .MuiListItemText-root": {
      color: "inherit",
    },
  },
}));

interface ListItemLinkProps {
  icon?: React.ReactNode;
  text: string;
  subItem?: boolean;
  onClick?: () => void;
}

const ListItemButton: React.FC<ListItemLinkProps> = ({
  icon,
  text,
  subItem,
  onClick,
}) => {
  const { classes } = useStyles();

  return (
    <li>
      <ListItem
        className={`${classes.listItem} ${subItem && classes.listItemSubItem}`}
        button
        onClick={onClick}
      >
        {Boolean(icon) && (
          <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
        )}
        <ListItemText
          className={classes.listItemText}
          classes={{ primary: classes.listItemTextPrimary }}
          primary={text}
          inset={!icon}
        />
      </ListItem>
    </li>
  );
};

export default ListItemButton;
